/**
 * Default project headers
 */
// eslint-disable-next-line import/prefer-default-export
export const headers = {
  'x-q24-project': 'admin',
  'x-q24-user-agent': `AdminDashboard/${process.env.REACT_APP_VERSION}`,
};
